export const Logo = () => (
    <a
        href="#top"
        data-testid="brand-logo"
        className="flex items-baseline gap-1 select-none"
        aria-label="Savv Media home"
    >
        <span className="font-serif-ed font-semibold tracking-tight text-2xl leading-none text-[#F1F1EF]">
            SAVV
        </span>
        <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            className="translate-y-[1px]"
            aria-hidden="true"
        >
            <path
                d="M12 20 C7.5 16.6 5 13.8 5 10.7 C5 8.2 7 6.5 9.2 6.5 C10.7 6.5 11.7 7.4 12 8.4 C12.3 7.4 13.3 6.5 14.8 6.5 C17 6.5 19 8.2 19 10.7 C19 13.8 16.5 16.6 12 20 Z"
                stroke="#D3A0A7"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    </a>
);
